import Resource from '@/api/resources/Resource'

class PredefinedCustomNotificationsService extends Resource {
    async getAllActivePredefinedCustomNotifications(laboratoryId, type) {
        const params = { type: type }
        const response = await this.axios.get(`/laboratories/${laboratoryId}/predefinedCustomNotifications`, { params: params })
        return response.data
    }
}

export default new PredefinedCustomNotificationsService()
